import React, { useState,useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import 'src/scss/ezp2/toogleMenu.css';
import {
    Profile,
    PhoneCall,
    Email,
    Dropdown,
    NavLink,
    Nav1,
    Nav2,
    Nav3,
    Nav4,
    Nav5,
    Nav6,
    Nav7
} from 'src/assets/index';
var appUrl = `${process.env.REACT_APP_API_HOST}`;

function ToggleMenu(props) {
    const state = useSelector((state) => state.memInfo);
    const history = useHistory();
    const { onClickMenu, isSelAfcr, isSelSection, isLife, isChange, onChgangeAfcr } = props;
    const historyPush = (page) => {
        if(history.location.pathname == ("/ezp-2/mem/"+page)){
            onClickMenu();
        }
        if(page === "signReg"){
            history.push("/ezp-2/mem/signReg")
        }
        if(page === "corpCrtf"){
            history.push("/ezp-2/mem/corpCrtf")
        }
        if(page === "myPage"){
            history.push("/ezp-2/mem/myPage")
        }
        if(page === "MemRegMng"){
            history.push("/ezp-2/mem/MemRegMng")
        }
        if(page === "easyPwdReg"){
            history.push("/ezp-2/easyPwdReg")
        }
        if(page === "TempPwPage"){
            history.push("/ezp-2/mem/TempPwPage")
        }
        if(page === "login"){
            let storage =  window.sessionStorage;
            storage.removeItem("accessToken");
            storage.removeItem("refreshToken");
            storage.removeItem("startDate");
            storage.removeItem("endDate");
            history.push("/ezp-2/login")
        }

    }
    


  return (
    <div className="menu-wrapper" id="slideMenu" >
         <div className="menu-wrapper-back"  onClick={onClickMenu}>
         </div>
         <div className="menu-wrapper-back2">
         </div>
        <div className="menu-container">
            {/* 유저 데이터 박스 */}
            <div className="userData-box">
                <div className="profileBox">
                <div className="profileImg4">
                    {state.prflFileNm !== null ? 
                    <img src={`${appUrl}ezp2/mem/:${(state.memNo != "" ? state.memNo : "0")}/memInfo/getImages/prflFileNm?${state.prflFileNm}`} alt="프로필" className="profileImg" />
                    :""}
                    {state.prflFileNm == null ? 
                    <img src={Profile} alt="프로필" className="profileImg" />
                    :""}
                </div>
                    <div className="toggleUserBox">
                        <h1 className="user"><span className='userName'>{state.memNm} 님</span><br/>안녕하세요.</h1>
                        {/* <p className="id">advsadsa486431</p> */}
                    </div>
                </div>
                <div className="userAdress-box">
                    <div className="sub-dataBox">
                        <img src={PhoneCall} alt="phone" />
                        <p className='sub-dataBox-value'>{state.memHphnNo}</p>
                    </div>

                    <div className="sub-dataBox">
                        <img src={Email} alt="phone" />
                        <p className='sub-dataBox-value'>{state.emal}</p>
                        {/* <img src={Dropdown} alt="phone" /> */}
                    </div>
                </div>
            </div>
            {/* 이동 메뉴 박스 */}
            <ul className="toggle-navBox">
                <li className="toggle-nav"onClick={() => historyPush("myPage")}> 
                    <a className="navLink">
                        <img src={Nav1} alt="/ezp-2/mem/myPage" />
                    </a>
                    <a className="navName">내 정보</a>
                    <a className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
                <li className="toggle-nav" onClick={() => historyPush("signReg")}>
                    <a className="navLink" >
                        <img src={Nav2} alt="/ezp-2/mem/signReg" />
                    </a>
                    <p className="navName">서명등록</p>
                    <a className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
                <li className="toggle-nav"  onClick={() => historyPush("corpCrtf")}> 
                    <a href="#" className="navLink">
                        <img src={Nav3} alt="#" />
                    </a>
                    <p className="navName">업체인증</p>
                    <a href="#" className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
                <li className="toggle-nav" onClick={() => historyPush("MemRegMng")}> 
                    <a className="navLink">
                        <img src={Nav4} alt="/ezp-2/mem/MemRegMng" />
                    </a>
                    <a className="navName">등록증 관리</a>
                    <a className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
                <li className="toggle-nav" onClick={() => historyPush("easyPwdReg")}> 
                    <a className="navLink">
                        <img src={Nav7} alt="#" />
                    </a>
                    <a className="navName">간편로그인 설정</a>
                    <a className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
                <li className="toggle-nav" onClick={() => historyPush("TempPwPage")}> 
                    <a className="navLink">
                        <img src={Nav5} alt="/ezp-2/mem/TempPwPage" />
                    </a>
                    <a className="navName">비밀번호 변경</a>
                    <a className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
                <li className="toggle-nav" onClick={() => historyPush("login")}> 
                    <a className="navLink">
                        <img src={Nav6} alt="/ezp-2/login" />
                    </a>
                    <a className="navName">로그아웃</a>
                    <a className="navLink">
                        <img src={NavLink} alt="이동" />
                    </a>
                </li>
            </ul>
        </div>
       
        
    </div>
  )
}

export default React.memo(ToggleMenu)